export default {
  all: [],
  one: {},
  templates: [],
  guests: [],
  hosts: [],
};
